import { Injectable } from '@angular/core';
import { SurveyService } from '../../../../../core/services/survey/survey.service';
import { QuestionsService } from '../../../../../core/services/survey/questions.service';
import { OfficesUtilsService } from '../../../../../core/services/utils/offices.utils.service';

@Injectable({
  providedIn: 'root'
})
export class MembershipApplicationValueChangesService {
  constructor(private officesUtilsService: OfficesUtilsService,
              private questionsService: QuestionsService,
              private surveyService: SurveyService
              ) {
  }

  officeSearchTypeValueChanges() {
    const surveyModel = this.surveyService.surveyModel;

    if (surveyModel.getValue('Office-Search-Type') === 'NewOffice') {
      surveyModel.setValue('DesignatedRealtor', 'Yes');

      const isCorpQuestion = this.questionsService.getQuestion('isCorp');
      this.officesUtilsService.setOfficeNameInSurvey(isCorpQuestion.value);
      surveyModel.getQuestionByName('DesignatedRealtor').readOnly = true;
      surveyModel.setVariable('show_DesignatedRealtor_question', false);
    } else {
      surveyModel.getQuestionByName('DesignatedRealtor').readOnly = false;
      surveyModel.clearValue('DesignatedRealtor');
      surveyModel.setVariable('show_DesignatedRealtor_question', true);
    }
  }
}
